var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(this.$route.name !== 'Farewell' && this.$route.name !== 'Friend')?_c('GlobalHeader'):_vm._e(),_c('section',{attrs:{"role":"main","id":"main-content"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }